import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IController, IModule} from "angular";
import _ from "lodash";
import IMenuService = angular.material.IMenuService;
import IMenu = angular.material.IMenu;
import {Konfigurasjon} from "felles/infrastruktur/Konfigurasjon";
import {Debugger} from "debug";

const debug: Debugger = require('debug')('MenyKontroller');
const css = require('./meny.scss');

/**
 * Viser angular material basert meny.
 * Bruk:
 * <wk-meny>
 *  <wk-meny-punkt ikon="mdi mdi-pencil" ng-click="ktr.rediger()">Rediger</wk-meny-punkt>
 *  <wk-meny-punkt ikon="ion-ios-trash" ng-click="ktr.slet()">slett</wk-meny-punkt>
 * </wk-meny>
 */
export function registrerMenyKomponent(angular: IModule) {
    MenyKontroller.registrerKomponent(angular);
    MenyPunktKontroller.registrerKomponent(angular);
    angular.service(MenyTjeneste.regNavn, MenyTjeneste.forInjisering());
}

export class MenyKontroller implements IController {
    static registrerKomponent(angular: IModule) {
        angular
            .component('wkMeny', {
                bindings: {
                    menyTittel: '<',
                    kanDeaktiveres: '@',
                    menyKlasse: '@'
                },
                controller: MenyKontroller.forInjisering(),
                template: require('./meny.html'),
                transclude: true
            });
    }

    static forInjisering() {
        return [regNavn.ng.material.$mdMenu, MenyTjeneste.regNavn, Konfigurasjon.regNavn, MenyKontroller]
    }

    constructor(private $mdMenu: IMenuService, private menyTjeneste: MenyTjeneste, private konfigurasjon:Konfigurasjon) {
    }

    menyTittel: string; //settes via bindings
    /** Dersom 'false' vil ikke menyen påvirkes av MenyTjeneste.erDeaktivert() */
    kanDeaktiveres: 'true'|'false'|null; //settes via bindings
    menyKlasse: string; //settes via bindings

    private menyPunkter: MenyPunktKontroller[] = [];

    klikk($mdMenu: IMenu, $event) {
        if (this.kanDeaktiveres != 'false' && this.menyTjeneste.erDeaktivert()) return;
        this.åpneMeny($mdMenu, $event);
    }

    musInn($mdMenu: IMenu, $event) {
    }

    musUt() {
    }

    registrerMenyPunkt(punkt: MenyPunktKontroller) {
        this.menyPunkter.push(punkt);
    }

    private åpneMeny($mdMenu: IMenu, $event) {
        _(this.menyPunkter).forEach(m => m.resetBekreftKlikk());
        $mdMenu.open($event);
    }

    lukkMeny() {
        _(this.menyPunkter).forEach(m => m.resetBekreftKlikk());
        this.$mdMenu.hide()
    }
}

export class MenyPunktKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wkMenyPunkt', {
                bindings: {
                    klikk: "&",
                    deaktivert: "<",
                    bekreftKlikk: "@",
                    ikon: "@"
                },
                controller: MenyPunktKontroller.forInjisering(),
                template: require('./menyPunkt.html'),
                transclude: true,
                require: {
                    meny: '^wkMeny'
                },
            });
    }

    static forInjisering() {
        return [MenyPunktKontroller]
    }

    klikk: Function; //settes via bindings/$onChanges
    deaktivert: boolean; //settes via bindings/$onChanges
    bekreftKlikk: string; //settes via bindings/$onChanges
    ikon: string; //settes via bindings/$onChanges
    meny: MenyKontroller; //settes via require

    erVisBekreftKlikkSteg = false;

    private visBekreftKlikkStegTidsstempel:number;

    vedKlikk($event) {
        if (this.deaktivert) return;

        if (this.erMenyPunktMedBekreftKlikk()) {
            if (this.erVisBekreftKlikkSteg){
                //ikke utfør handling med mindre det har gått minst 500ms siden initielt klikk
                if ((new Date().getTime() - this.visBekreftKlikkStegTidsstempel) > 500)
                    this.kallKlikk($event)

            } else {
                this.visBekreftKlikkStegTidsstempel = new Date().getTime();
                this.erVisBekreftKlikkSteg = true
            }
            return;
        }

        this.kallKlikk($event);
    }

    erMenyPunktMedBekreftKlikk() {
        return this.bekreftKlikk;
    }

    $onInit(): void {
        this.meny.registrerMenyPunkt(this)
    }

    resetBekreftKlikk() {
        this.erVisBekreftKlikkSteg = false;
    }

    //hjelpemetoder

    private kallKlikk($event) {
        this.meny.lukkMeny();
        if (this.klikk) this.klikk({$event: $event});
    }
}

const debugMt: Debugger = require('debug')('MenyTjeneste');

export class MenyTjeneste {
    static regNavn = "wk.meny.MenyTjeneste";

    static forInjisering() {
        return [MenyTjeneste]
    }

    menyerDeaktivert = false;

    deaktiverMenyer() {
        debugMt('deaktiverMenyer')
        this.menyerDeaktivert = true;
    }

    aktiverMenyer() {
        debugMt('aktiverMenyer')
        this.menyerDeaktivert = false;
    }

    erDeaktivert() {
        return this.menyerDeaktivert;
    }

    erAktivert() {
        return !this.erDeaktivert();
    }
}
